import React, { PropsWithChildren, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import tw from 'twin.macro';
import LoadingIndicator from '../../../component/atom/LoadingIndicator/LoadingIndicator.atom';
import SnackbarAdapter from '../../../component/molecule/Snackbar/SnackbarAdapter.molecule';
import MobileHeader from '../../../component/organism/main/MobileHeader/MobileHeader.organism';
import MobileNav from '../../../component/organism/main/MobileNav/MobileNav.organism';
import Sidebar from '../../../component/organism/main/Sidebar/Sidebar.organism';
import { sidebarConfig } from '../../../config/router/router.config';
import useWrapperViewModel from './Wrapper.viewModel';

const Container = tw.div`min-h-screen w-full bg-secondary-50 flex flex-col`;
const AuthenticationContainer = tw.div`flex items-center justify-center h-screen w-full flex-col`;
const SidebarBackdrop = tw.div`fixed inset-0 z-40 bg-black/40`;
const SidebarPanel = tw.div`fixed left-0 top-0 z-50 h-screen w-60 bg-white border-r border-gray-100`;
const ContentWrapper = tw.div`flex-1 w-full bg-backgroundColor overflow-x-hidden pt-14 pb-16`;
const ContentArea = tw.div`w-full h-full`;

export default function WrapperMobileView({
  children,
}: PropsWithChildren<Record<string, unknown>>) {
  const { sidebar, location, session } = useWrapperViewModel();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  if (session.isLoading) {
    return (
      <Container>
        <AuthenticationContainer>
          <LoadingIndicator />
        </AuthenticationContainer>
      </Container>
    );
  }

  return (
    <Container id='rootContainer'>
      {!sidebar.hideSidebar && (
        <MobileHeader onMenuClick={() => setSidebarOpen(true)} />
      )}
      <ToastContainer
        theme='light'
        position='bottom-center'
        autoClose={3000}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        draggable
        hideProgressBar
      />
      {!sidebar.hideSidebar && sidebarOpen && (
        <>
          <SidebarBackdrop onClick={() => setSidebarOpen(false)} />
          <SidebarPanel>
            <Sidebar
              items={sidebarConfig}
              currentPath={location.pathname}
              onItemClick={(path, externalLink) => {
                sidebar.onSidebarItemClick(path, externalLink);
                setSidebarOpen(false);
              }}
              expandedSidebar
              onBurgerClick={() => setSidebarOpen(false)}
            />
          </SidebarPanel>
        </>
      )}
      <ContentWrapper
        style={sidebar.hideSidebar ? { paddingTop: 0, paddingBottom: 0 } : undefined}
      >
        <ContentArea>{children}</ContentArea>
        <SnackbarAdapter />
      </ContentWrapper>
      {!sidebar.hideSidebar && <MobileNav />}
    </Container>
  );
}
